import { FormControl, MenuItem, Select } from "@mui/material";
import { GridLogicOperator } from "@mui/x-data-grid";
import { CustomDataGridFilterLogicOperatorProps } from "../Interfaces/CustomDataGrid.interfaces";

export const CustomDataGridFilterLogicOperatorDropdown = ({
  disabled,
  onChange,
  value
}: CustomDataGridFilterLogicOperatorProps) => (
  <FormControl size="small" sx={{ width: 80 }}>
    <Select
      disabled={disabled}
      displayEmpty
      inputProps={{ "aria-label": "Logic Operator" }}
      onChange={(event) => onChange(event.target.value as GridLogicOperator)}
      renderValue={(selected) => (selected === GridLogicOperator.Or ? "Or" : "And")}
      value={value}
      sx={{
        ".MuiSelect-select": { py: 0.5, px: 1.5 },
        background: "transparent",
        fontSize: 14,
        height: 32
      }}
    >
      <MenuItem value={GridLogicOperator.And}>And</MenuItem>
      <MenuItem value={GridLogicOperator.Or}>Or</MenuItem>
    </Select>
  </FormControl>
);
